import React from 'react';

const CardVisa = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="visa_mask0_19470_2945"
        style={{"maskType":"luminance"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path d="M0 0H20V20H0V0Z" fill="white" />
      </mask>
      <g mask="url(#visa_mask0_19470_2945)">
        <mask
          id="visa_mask1_19470_2945"
          style={{"maskType":"luminance"}}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path d="M0 0H20V20H0V0Z" fill="white" />
        </mask>
        <g mask="url(#visa_mask1_19470_2945)">
          <path d="M0 0H20V20H0V0Z" fill="#1C33C3" />
          <path
            d="M12.1353 5.55554L9.82531 11.5233L8.86309 6.44443C8.7342 5.87332 8.28531 5.55554 7.83642 5.55554H4.50976L4.44531 5.80999C5.21531 5.99999 5.7942 6.18999 6.30753 6.44443C6.46754 6.52443 6.60087 6.66665 6.68198 7.26999L8.34976 14.4444H10.7231L14.4453 5.55554H12.1353Z"
            fill="url(#visa_paint0_linear_19470_2945)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="visa_paint0_linear_19470_2945"
          x1="85.2153"
          y1="120.56"
          x2="86.9464"
          y2="51.0911"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default CardVisa;
